import axiosInstance from '../../common/axios.service';
import FILTERS from '../../common/filters.type';
import {ADD_CUSTOMER, UPDATE_CUSTOMER} from './customers.types';

const customersList = (values: FILTERS) => {
  return axiosInstance.get('customer/', {params: values}).then((response) => {
    return response;
  });
};
const addCustomer = (values: ADD_CUSTOMER) => {
  return axiosInstance.post('customer', values).then((response) => {
    return response;
  });
};

const updateCustomer = (values: {payload: UPDATE_CUSTOMER; id: number}) => {
  return axiosInstance.put(`customer/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const customerBattery = (id: number) => {
  return axiosInstance.get(`customerbattery/${id}`).then((response) => {
    return response;
  });
};

const getPlans = () => {
  return axiosInstance.get('payment/plan').then((response) => {
    return response;
  });
};

const getCustomerPlans = (id: number) => {
  return axiosInstance.get(`payment/assignplan/${id}`).then((response) => {
    return response;
  });
};

const updateCustomerPlan = (payload: {customer_id: number; paymentObject: any}) => {
  return axiosInstance.post('payment/create', payload).then((response) => {
    return response;
  });
};

const customerServices = {
  customersList,
  updateCustomer,
  addCustomer,
  customerBattery,
  getPlans,
  getCustomerPlans,
  updateCustomerPlan,
};

export default customerServices;
